import groupService from '@/services/group';
import EventBus from '@/utils/eventBus';
import * as types from './mutation-types';

export const getGroup = ({
  commit,
  state,
}, filter) => {
  if (!filter && state.lastFilter) {
    filter = state.lastFilter;
  }

  EventBus.$emit('show-loading', true);
  groupService.countAll((err, i) => {
    groupService.get(filter, (e, res) => {
      EventBus.$emit('show-loading', false);
      const data = res.data;
      commit(types.GET_GROUP, {
        lastFilter: filter,
        groups: data,
        count: i.data.count,
      });
    });
  });
};

export default {
  getGroup,
};




// WEBPACK FOOTER //
// ./src/store/modules/group/actions.js